module.exports = __webpack_public_path__ + "img/Logo-tuyouke.f58a1614.png";